import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { Accordion, AccordionContent, AccordionTitle, AccordionTitleProps, Icon } from "semantic-ui-react";


interface Props {
    title: string;
    containerClassNames?: string;
    classNames?: string;
}

export default observer(function AccordionContainer({ title, containerClassNames, classNames, children }: React.PropsWithChildren<Props>) {
    const [activeAccordionIdx, setActiveAccordionIdx] = useState<number>(-1);
    const handleChange = useCallback((event: React.MouseEvent<HTMLDivElement>, data: AccordionTitleProps) => {
        const { index } = data;
        const newIndex = activeAccordionIdx === index ? -1 : (index ?? "0") as number;

        setActiveAccordionIdx(newIndex)
    }, [activeAccordionIdx]);

    return (
        <Accordion className={containerClassNames ?? ""}>
            <AccordionTitle
                index={0}
                active={activeAccordionIdx === 0}
                onClick={handleChange}
                className="myLabel"
            >
                <Icon name='dropdown' />
                {title}
            </AccordionTitle>
            <AccordionContent
                index={0}
                active={activeAccordionIdx === 0}
                className={classNames ?? ""}
            >
                {children}
            </AccordionContent>
        </Accordion>
    );
});
